<!-- Separator element with text in the center and short lines on either side -->
<template>
  <div class="text-separator d-flex align-items-center column-gap-md">
    <div class="separator-line"/>
    <p class="small-text">
      {{ text }}
    </p>
    <div class="separator-line"/>
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.text-separator {
  height: 45px;

  .separator-line {
    flex: 1;
    height: 1px;
    background-color: $ash;
  }
}
</style>
